import React from "react";
import { FaPhoneAlt, FaTruck, FaBoxes, FaRecycle } from "react-icons/fa";
import "./WasteManagement.css";

const WasteManagement = () => {
  const services = [
    {
      icon: <FaPhoneAlt className="waste-icon" />,
      title: "Easy Scheduling",
      description: "Book your junk removal in minutes with our online scheduling or quick phone call. We offer same-day service for urgent needs.",
      gradient: "linear-gradient(135deg, #10B981, #3B82F6)"
    },
    {
      icon: <FaTruck className="waste-icon" />,
      title: "Fast Pickup",
      description: "Our crew arrives on time with all equipment needed to remove your items quickly and safely.",
      gradient: "linear-gradient(135deg, #F59E0B, #EF4444)"
    },
    {
      icon: <FaBoxes className="waste-icon" />,
      title: "Careful Sorting",
      description: "We separate recyclables from trash right at your property to maximize eco-friendly disposal.",
      gradient: "linear-gradient(135deg, #8B5CF6, #EC4899)"
    },
    {
      icon: <FaRecycle className="waste-icon" />,
      title: "Responsible Disposal",
      description: "All junk is processed at local recycling centers and donation facilities whenever possible.",
      gradient: "linear-gradient(135deg, #14B8A6, #0EA5E9)"
    }
  ];

  return (
    <section className="waste-section">
      <div className="waste-container">
        {/* Header Section */}
        <div className="waste-header">
          <h2 className="waste-title">
            Tacoma's <span className="waste-title-highlight">Premium</span> Junk Removal
          </h2>
          <p className="waste-subtitle">
            Fast, affordable, and eco-friendly junk removal services.
          </p>
          <div className="waste-divider">
            <span className="waste-divider-line"></span>
            <span className="waste-divider-dot"></span>
            <span className="waste-divider-line"></span>
          </div>
        </div>

        {/* Content Section */}
        <div className="waste-content">
          <div className="waste-image-container">
            <img 
              src="./IMG_0955.webp" 
              alt="Tacoma Junk Removal" 
              className="waste-image"
              loading="lazy"
            />
      
          </div>

          <div className="waste-services-container">
            <div className="waste-process">
              <h3 className="waste-process-title">
                Our <span className="waste-process-highlight">Service</span> Process
              </h3>
              <p className="waste-process-description">
                As Tacoma's junk removal experts, we have perfected a four-step system to clear your space quickly while reducing environmental impact.
              </p>
            </div>

            <div className="waste-services-grid">
              {services.map((service, index) => (
                <div className="waste-service-card" key={index}>
                  <div 
                    className="waste-service-icon" 
                    style={{ background: service.gradient }}
                  >
                    {service.icon}
                  </div>
                  <div className="waste-service-content">
                    <h4 className="waste-service-title">{service.title}</h4>
                    <p className="waste-service-description">{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WasteManagement;